<footer class="footer container">
  <p>SRS {{currentYear}}</p>
</footer>
